// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file registration_info_status.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file registration_info_status.proto.
 */
export const file_registration_info_status: GenFile = /*@__PURE__*/
  fileDesc("Ch5yZWdpc3RyYXRpb25faW5mb19zdGF0dXMucHJvdG8SBmRvbWFpbiqtBAoWUmVnaXN0cmF0aW9uSW5mb1N0YXR1cxIkCiBSRUdJU1RSQVRJT05fSU5GT19TVEFUVVNfVU5LTk9XThAAEisKJ1JFR0lTVFJBVElPTl9JTkZPX1NUQVRVU19BVkFJTEFCTEVfRlJFRRABEjoKNlJFR0lTVFJBVElPTl9JTkZPX1NUQVRVU19BVkFJTEFCTEVfU1RBUlRfQ09ERV9SRVFVSVJFRBACEkEKPVJFR0lTVFJBVElPTl9JTkZPX1NUQVRVU19VTkFWQUlMQUJMRV9SRVNFUlZFRF9WRVJJRklFRF9ET01BSU4QAxJACjxSRUdJU1RSQVRJT05fSU5GT19TVEFUVVNfVU5BVkFJTEFCTEVfUkVDT1ZFUl9WSUFfQkFDS1VQX0NPREUQBBI6CjZSRUdJU1RSQVRJT05fSU5GT19TVEFUVVNfVU5BVkFJTEFCTEVfUkVDT1ZFUl9WSUFfQURNSU4QBRJJCkVSRUdJU1RSQVRJT05fSU5GT19TVEFUVVNfVU5BVkFJTEFCTEVfUkVDT1ZFUl9WSUFfQkFDS1VQX0NPREVfT1JfQURNSU4QBhI+CjpSRUdJU1RSQVRJT05fSU5GT19TVEFUVVNfVU5BVkFJTEFCTEVfQURNSU5fQUNUSU9OX1JFUVVJUkVEEAcSOAo0UkVHSVNUUkFUSU9OX0lORk9fU1RBVFVTX1VOQVZBSUxBQkxFX05PVF9SRUNPVkVSQUJMRRAIQlIKGmFwcC5oZXlsb2dpbi5hbmRyb2lkLnByb3RvWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiogIDSFBBYgZwcm90bzM");

/**
 * @generated from enum domain.RegistrationInfoStatus
 */
export enum RegistrationInfoStatus {
  /**
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * if no account exists for this address, and it can be freely registered
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_AVAILABLE_FREE = 1;
   */
  AVAILABLE_FREE = 1,

  /**
   * if an account exists, and can be registered by providing a start code
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_AVAILABLE_START_CODE_REQUIRED = 2;
   */
  AVAILABLE_START_CODE_REQUIRED = 2,

  /**
   * if address belongs to a verified domain. requires an admin to set up an account first.
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_RESERVED_VERIFIED_DOMAIN = 3;
   */
  UNAVAILABLE_RESERVED_VERIFIED_DOMAIN = 3,

  /**
   * if account is in use, and can be recovered via backup code
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_RECOVER_VIA_BACKUP_CODE = 4;
   */
  UNAVAILABLE_RECOVER_VIA_BACKUP_CODE = 4,

  /**
   * if account is in use, and can be recovered by an admin (disconnect + start code)
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_RECOVER_VIA_ADMIN = 5;
   */
  UNAVAILABLE_RECOVER_VIA_ADMIN = 5,

  /**
   * if account is in use, and can be recovered via backup code or org admin
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_RECOVER_VIA_BACKUP_CODE_OR_ADMIN = 6;
   */
  UNAVAILABLE_RECOVER_VIA_BACKUP_CODE_OR_ADMIN = 6,

  /**
   * if account is a free profile, but no start code (deprecated: or email invite) is active
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_ADMIN_ACTION_REQUIRED = 7;
   */
  UNAVAILABLE_ADMIN_ACTION_REQUIRED = 7,

  /**
   * if account is in use, and can't be recovered
   *
   * @generated from enum value: REGISTRATION_INFO_STATUS_UNAVAILABLE_NOT_RECOVERABLE = 8;
   */
  UNAVAILABLE_NOT_RECOVERABLE = 8,
}

/**
 * Describes the enum domain.RegistrationInfoStatus.
 */
export const RegistrationInfoStatusSchema: GenEnum<RegistrationInfoStatus> = /*@__PURE__*/
  enumDesc(file_registration_info_status, 0);

